export const setOrderMethod = method => ({
    type: actionTypes.SET_ORDER_METHOD,
    payload: { method },
})

export const updateOrderMethodRedux = payload => ({
    type: actionTypes.UPDATE_ORDER_METHOD_REDUX,
    payload,
})

export const updateOrder = payload => ({
    type: actionTypes.UPDATE_ORDER,
    payload,
})

export const setDeliverPosition = payload => ({
    type: actionTypes.SET_DELIVER_POSITION,
    payload,
})

export const verifyTable = payload => ({
    type: actionTypes.VERIFY_TABLE,
    payload,
})

export const verifyTableSuccess = payload => ({
    type: actionTypes.VERIFY_TABLE_SUCCESS,
    payload,
})

export const verifyQRCode = payload => ({
    type: actionTypes.VERIFY_QRCODE,
    payload,
})

export const verifyQRCodeSuccess = payload => ({
    type: actionTypes.VERIFY_QRCODE_SUCCESS,
    payload,
})

export const addToCart = payload => ({
    type: actionTypes.ADD_FOOD_TO_CART,
    payload,
})

export const addFoodGroupToCart = payload => ({
    type: actionTypes.ADD_FOOD_GROUP,
    payload,
})

export const removeItem = payload => ({
    type: actionTypes.REMOVE_ITEM,
    payload,
})

export const setRestaurantPath = restaurantPath => ({
    type: actionTypes.SET_RESTAURANT_PATH,
    payload: { restaurantPath },
})

export const submitOrder = payload => ({
    type: actionTypes.SUBMIT_ORDER,
    payload,
})

export const submitOrderSuccess = payload => ({
    type: actionTypes.SUBMIT_ORDER_SUCCESS,
    payload,
})

export const submitOrderTakeAGoSuccess = payload => ({
    type: actionTypes.SUBMIT_ORDER_TAKE_A_GO_SUCCESS,
    payload,
})

export const requestPayment = payload => ({
    type: actionTypes.REQUEST_PAYMENT,
    payload,
})

export const requestPaymentSuccess = payload => ({
    type: actionTypes.REQUEST_PAYMENT_SUCCESS,
    payload,
})

export const searchLocation = payload => ({
    type: actionTypes.SEARCH_LOCATION,
    payload,
})

export const calcDistance = payload => ({
    type: actionTypes.CALC_DISTANCE,
    payload,
})

export const saveOrder = payload => ({
    type: actionTypes.SAVE_ORDER,
    payload,
})

export const getOrderDetails = payload => ({
    type: actionTypes.GET_ORDER_DETAILS,
    payload,
})

export const setTmpFoods = payload => ({
    type: actionTypes.SET_TMP_FOODS,
    payload,
})

export const setViewFoodDetails = payload => ({
    type: actionTypes.SET_VIEW_FOOD_DETAILS,
    payload,
})

export const getOrdersQRCode = payload => ({
    type: actionTypes.GET_ORDERS_QRCODE,
    payload,
})

export const getOrdersQRCodeSuccess = payload => ({
    type: actionTypes.GET_ORDERS_QRCODE_SUCCESS,
    payload,
})

export const updateAmount = payload => ({
    type: actionTypes.UPDATE_AMOUNT,
    payload,
})

export const updateNote = payload => ({
    type: actionTypes.UPDATE_NOTE,
    payload,
})

export const checkTableValid = payload => ({
    type: actionTypes.CHECK_TABLE_VALID,
    payload,
})

export const closeNotiDoneOrder = payload => ({
    type: actionTypes.CLOSE_NOTI_DONE_ORDER,
    payload,
})

export const getOrderInfo = payload => ({
    type: actionTypes.GET_ORDER_INFO,
    payload,
})

export const payOther = payload => ({
    type: actionTypes.PAY_OTHER,
    payload,
})

export const addGroupOrder = payload => ({
    type: actionTypes.ADD_GROUP_ORDER,
    payload,
})

export const selectGroupOrder = payload => ({
    type: actionTypes.SELECT_GROUP_ORDER,
    payload,
})

export const delGroupOrder = payload => ({
    type: actionTypes.DEL_GROUP_ORDER,
    payload,
})

export const clearExpireTime = payload => ({
    type: actionTypes.CLEAR_EXPIRE_TIME,
    payload,
})

export const setTabletOrderMethod = payload => ({
    type: actionTypes.SET_TABLET_ORDER_METHOD,
    payload,
})

export const setTabletForm = payload => ({
    type: actionTypes.SET_TABLE_FORM,
    payload,
})

export const resetCart = () => ({
    type: actionTypes.RESET_CART,
})

export const checkTableValidSuccess = payload => ({
    type: actionTypes.CHECK_TABLE_VALID_SUCCESS,
    payload,
})

export const setPrinterSelectData = payload => ({
    type: actionTypes.SET_PRINTER_SELECT_DATA,
    payload,
})

export const updateFoodPrinter = payload => ({
    type: actionTypes.UPDATE_FOOD_PRINTER,
    payload,
})

export const actionTypes = {
    SET_ORDER_METHOD: 'SET_ORDER_METHOD',
    UPDATE_ORDER_METHOD_REDUX: 'UPDATE_ORDER_METHOD_REDUX',
    UPDATE_ORDER: 'UPDATE_ORDER',
    SET_TABLET_ORDER_METHOD: 'SET_TABLET_ORDER_METHOD',
    SET_DELIVER_POSITION: 'SET_DELIVER_POSITION',

    CHECK_TABLE_VALID: 'CHECK_TABLE_VALID',
    CHECK_TABLE_VALID_SUCCESS: 'CHECK_TABLE_VALID_SUCCESS',
    VERIFY_TABLE: 'VERIFY_TABLE',
    VERIFY_TABLE_SUCCESS: 'VERIFY_TABLE_SUCCESS',
    VERIFY_QRCODE: 'VERIFY_QRCODE',
    VERIFY_QRCODE_SUCCESS: 'VERIFY_QRCODE_SUCCESS',
    SET_RESTAURANT_PATH: 'SET_RESTAURANT_PATH',

    ADD_FOOD_TO_CART: 'ADD_FOOD_TO_CART',
    ADD_FOOD_GROUP: 'ADD_FOOD_GROUP',
    REMOVE_ITEM: 'REMOVE_ITEM',
    RESET_CART: 'RESET_CART',

    GET_ORDER_DETAILS: 'GET_ORDER_DETAILS',
    GET_ORDERS_QRCODE: 'GET_ORDERS_QRCODE',
    GET_ORDERS_QRCODE_SUCCESS: 'GET_ORDERS_QRCODE_SUCCESS',
    SAVE_ORDER: 'SAVE_ORDER',
    SUBMIT_ORDER: 'SUBMIT_ORDER',
    SUBMIT_ORDER_SUCCESS: 'SUBMIT_ORDER_SUCCESS',
    SUBMIT_ORDER_TAKE_A_GO_SUCCESS: 'SUBMIT_ORDER_TAKE_A_GO_SUCCESS',
    REQUEST_PAYMENT: 'REQUEST_PAYMENT',
    REQUEST_PAYMENT_SUCCESS: 'REQUEST_PAYMENT_SUCCESS',

    SEARCH_LOCATION: 'SEARCH_LOCATION',
    CALC_DISTANCE: 'CALC_DISTANCE',

    SET_TMP_FOODS: 'SET_TMP_FOODS',
    SET_VIEW_FOOD_DETAILS: 'SET_VIEW_FOOD_DETAILS',

    UPDATE_AMOUNT: 'UPDATE_AMOUNT',
    UPDATE_NOTE: 'UPDATE_NOTE', // for each food

    CLOSE_NOTI_DONE_ORDER: 'CLOSE_NOTI_DONE_ORDER',
    GET_ORDER_INFO: 'GET_ORDER_INFO',
    PAY_OTHER: 'PAY_OTHER',

    ADD_GROUP_ORDER: 'ADD_GROUP_ORDER',
    SELECT_GROUP_ORDER: 'SELECT_GROUP_ORDER',
    DEL_GROUP_ORDER: 'DEL_GROUP_ORDER',

    CLEAR_EXPIRE_TIME: 'CLEAR_EXPIRE_TIME',
    SET_TABLE_FORM: 'SET_TABLE_FORM',

    CLEAR_DISTANCE: 'CLEAR_DISTANCE',
    SET_PRINTER_SELECT_DATA: 'SET_PRINTER_SELECT_DATA',
    UPDATE_FOOD_PRINTER: 'UPDATE_FOOD_PRINTER',
    CLEAR_ALL_ORDER_DATA: 'CLEAR_ALL_ORDER_DATA',
    
}
